import React from "react";

export const PRINTER_TYPES = [
    { value: "laser", label: "Laser" },
    { value: "inkjet", label: "Jet d'encre" },
    { value: "multifunction", label: "Multifonction" },
    { value: "plotter", label: "Traceur / Plan" },
    { value: "label", label: "Étiqueteuse" },
    { value: "other", label: "Autre" },
];

export const PRINTER_STATUS = {
    active: { label: "Active", color: "bg-emerald-100 text-emerald-700" },
    broken: { label: "En panne", color: "bg-red-100 text-red-700" },
    maintenance: { label: "Maintenance", color: "bg-orange-100 text-orange-700" },
    retired: { label: "Retirée", color: "bg-gray-200 text-gray-600" },
};

export const CONSUMABLE_TYPES = [
    { value: "toner", label: "Toner" },
    { value: "cartridge", label: "Cartouche d'encre" },
    { value: "printhead", label: "Tête d'impression" },
    { value: "paper_roll", label: "Rouleau papier (plan)" },
    { value: "drum", label: "Tambour" },
    { value: "maintenance_kit", label: "Kit de maintenance" },
    { value: "other", label: "Autre" },
];

export const CONSUMABLE_COLORS = [
    { value: "", label: "—" },
    { value: "black", label: "Noir" },
    { value: "cyan", label: "Cyan" },
    { value: "magenta", label: "Magenta" },
    { value: "yellow", label: "Jaune" },
    { value: "color", label: "Couleur (tri)" },
];

export const COMPANY_TYPES = {
    supplier: "Fournisseur consommables",
    maintenance: "Maintenance / SAV",
    both: "Fournisseur + Maintenance",
};

export const MOVEMENT_KINDS = {
    purchase: { label: "Achat", color: "bg-emerald-100 text-emerald-700" },
    consumption: { label: "Consommation", color: "bg-blue-100 text-blue-700" },
    adjustment: { label: "Ajustement", color: "bg-gray-100 text-gray-600" },
};

export const CHECK_CONDITIONS = {
    ok: { label: "OK", color: "bg-emerald-100 text-emerald-700" },
    warning: { label: "À surveiller", color: "bg-orange-100 text-orange-700" },
    problem: { label: "Problème", color: "bg-red-100 text-red-700" },
};

export const fmtDate = (iso) => (iso ? new Date(iso).toLocaleDateString("fr-CH") : "—");
export const fmtNum = (n) => (n === null || n === undefined || n === "" ? "—" : Number(n).toLocaleString("fr-CH"));
export const fmtMoney = (n, cur = "CHF") => (n === null || n === undefined || n === "" ? "—" : `${Number(n).toLocaleString("fr-CH", { minimumFractionDigits: 2, maximumFractionDigits: 2 })} ${cur}`);
export const labelOf = (list, v) => list.find((t) => t.value === v)?.label || v || "—";
export const SELECT_CLS = "w-full h-9 px-2 text-sm border rounded-md bg-white";

export function Pill({ className = "", children, testId, title }) {
    return <span data-testid={testId} title={title} className={`inline-flex items-center gap-1 text-[9px] px-1.5 py-0.5 rounded-full font-medium whitespace-nowrap ${className}`}>{children}</span>;
}

export function PrinterStatusBadge({ status, testId }) {
    const cfg = PRINTER_STATUS[status] || PRINTER_STATUS.active;
    return <Pill className={cfg.color} testId={testId}>{cfg.label}</Pill>;
}

export function StockBadge({ consumable, testId }) {
    const q = consumable.quantity || 0;
    if (q <= 0) return <Pill className="bg-red-100 text-red-700" testId={testId}>Rupture</Pill>;
    if (consumable.is_low) return <Pill className="bg-orange-100 text-orange-700" testId={testId}>Stock bas</Pill>;
    return <Pill className="bg-emerald-100 text-emerald-700" testId={testId}>OK</Pill>;
}

export function WarrantyBadge({ end }) {
    if (!end) return <span className="text-gray-300 text-xs">—</span>;
    const diff = (new Date(end) - new Date()) / 86400000;
    if (diff < 0) return <Pill className="bg-red-100 text-red-700">Expirée</Pill>;
    if (diff < 30) return <Pill className="bg-orange-100 text-orange-700">Bientôt</Pill>;
    return <Pill className="bg-green-100 text-green-700">OK</Pill>;
}

export function CheckBadge({ printer, overdueDays = 90 }) {
    if (!printer.last_check_at) return <Pill className="bg-gray-100 text-gray-500 border border-dashed border-gray-300">Jamais contrôlée</Pill>;
    const days = Math.floor((new Date() - new Date(printer.last_check_at)) / 86400000);
    const cls = days > overdueDays ? "bg-orange-100 text-orange-700" : "bg-gray-100 text-gray-600";
    return <Pill className={cls} title={`Il y a ${days} jour(s)`}>{fmtDate(printer.last_check_at)}</Pill>;
}

export function Field({ label, children, className = "" }) {
    return (
        <div className={className}>
            <label className="block text-[10px] font-semibold uppercase tracking-wide text-gray-500 mb-1">{label}</label>
            {children}
        </div>
    );
}
